export enum RouteName {
  "shipments" = "shipments",
  "shipments_details" = "shipments-id",
  "shipments_label" = "shipments-id-label",
  "shipments_import" = "shipments-import",
  "shipments_import_list" = "shipments-import-list",
  "consignments" = "consignments",
  "returns" = "returns",
  "tickets" = "tickets",
  "tickets_details" = "tickets-id",
  "sortings" = "sortings",
  "sortings_returning" = "sortings-returning",
  "sortings_direction" = "sortings-direction",
  "sortings_terminal" = "sortings-terminal",
  "dashboard" = "dashboard",
  "prices" = "prices",
  "documents" = "documents",
  "invoices" = "invoices",
  "invoices_old" = "invoices-old",
  "checkouts_test" = "checkouts-test",
  "checkouts_analytics" = "checkouts-analytics",
  "login" = "auth-login",
  "register" = "auth-register",
  "reset" = "auth-reset",
  "reset_password" = "auth-reset-password",
  "logout" = "auth-logout",
  "purchase_orders" = "purchase-orders",
  "purchase_orders_details" = "purchase-orders-id",
  "seafreight" = "seafreight",
  "seafreight_details" = "seafreight-id",
  "containers" = "containers",
  "containers_details" = "containers-id",
  "cookies" = "cookies",
  "click_collect" = "clickcollect",
  "contacts" = "contacts",
  "orders" = "orders",
  "orders_pack" = "orders-pack",
  "unauthorized" = "403",
  "b2b_prices" = "b2b-prices",
}
